import { TrackRoute } from '@portals/shared-frontend/components';

import { useInternalApiFilterParams } from '@/hooks/useInternalApiFilterParams';
import { ExplorerPage } from '@/pages/explorer/components/ExplorerPage';
import { FilterTags } from '@/pages/explorer/filters/FilterTags';

import { InternalApiFilter } from './InternalApiFilter';
import { PaginatedInternalApis } from './PaginatedInternalApis';

export default function InternalApis() {
  const filterParams = useInternalApiFilterParams();

  return (
    <ExplorerPage filterTags={<FilterTags {...filterParams} />} filters={<InternalApiFilter />} title="Internal APIs">
      <TrackRoute name="Internal APIs" path="/explorer/apis/internal" type="internal" />
      <PaginatedInternalApis />
    </ExplorerPage>
  );
}
